import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-no-data',
    templateUrl: './no-data.component.html',
    standalone: false
})
export class NoDataComponent {
  @Input() message: string = 'App.NoData.Messages.Default';
  @Input() imageSrc: string = 'img/empty-box-ppu.svg';

  constructor(public translate: TranslateService) {}
}